import axiosInstance from "@/app/api";
import {ManageBookingResponse, TripRatingResponse} from "@/types/booking";

const manageBooking = async (request: any): Promise<ManageBookingResponse> => {
  return await axiosInstance()
    .post("/api/v2/manage/bookings", request)
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<ManageBookingResponse> = response.data;
        if (neoresponse && neoresponse.data) {
          return neoresponse.data;
        }
        return {} as ManageBookingResponse;
      }
      return {} as ManageBookingResponse;
    })
    .catch((error: any) => {
      return {} as ManageBookingResponse;
    });
};

const tripRating = async (): Promise<any> => {
  return await axiosInstance()
    .get("/api/v2/trip/rating/list")
    .then((response: any) => {
      if (response?.data?.status === "success") {
        const neoresponse: NeoResponse<TripRatingResponse> = response.data;
        const row = neoresponse?.data?.ratingList?.map(row => ({
          ...row
        }));
        return {
          rows: row,
          meta: neoresponse?.meta
        } as TableResponse<TripRatingResponse>;
      }
      return {} as TripRatingResponse;
    })
    .catch((error: any) => {
      return {} as TripRatingResponse;
    });
};

export const bookingService = {
  manageBooking,
  tripRating
};
